import React from 'react';
import { ResponsiveImage } from './ResponsiveImage';
import { Link } from 'react-router-dom';
import { ArrowRight, ChevronRight } from 'lucide-react';
import { hiringAdvice, careerAdvice } from '../data/mock';

const Articles = () => {
  return (
    <section data-testid="home-articles" className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Hiring Advice Section - Sans images */}
        <div className="mb-12">
          <div className="flex flex-wrap justify-between items-center gap-4 mb-6">
            <h3 data-testid="home-recrutement-heading" className="text-xl font-semibold text-gray-800">Conseils en recrutement</h3>
            <Link to="/conseils-recrutement" data-testid="home-all-recrutement-link" className="text-[#E30022] hover:underline font-medium flex items-center gap-1">
              Voir tous
              <ChevronRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            {hiringAdvice.map((article) => (
              <article 
                key={article.id}
                className="bg-gray-50 rounded-lg p-6 hover:bg-gray-100 transition-colors group hover-lift"
              >
                <span data-testid={`home-recrutement-${article.slug}-category`} className="inline-block bg-[#E30022] text-white px-3 py-1 text-xs rounded mb-3">
                  {article.category}
                </span>
                <h4 data-testid={`home-recrutement-${article.slug}-title`} className="text-lg font-semibold text-gray-800 mb-3 group-hover:text-[#E30022] transition-colors">
                  {article.title}
                </h4>
                <p data-testid={`home-recrutement-${article.slug}-excerpt`} className="text-gray-600 text-sm mb-4 line-clamp-2">
                  {article.excerpt}
                </p>
                <Link
                  to={article.link}
                  data-testid={`home-recrutement-${article.slug}-link`}
                  aria-label={`En savoir plus : ${article.title}`}
                  className="inline-flex items-center gap-2 text-[#E30022] font-medium text-sm hover:underline"
                >
                  En savoir plus
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </article>
            ))}
          </div>
        </div>

        {/* Career Advice Section */}
        <div>
          <div className="flex flex-wrap justify-between items-center gap-4 mb-6">
            <h3 data-testid="home-carriere-heading" className="text-xl font-semibold text-gray-800">Conseils carrière</h3>
            <Link to="/conseils-carriere" data-testid="home-all-carriere-link" className="text-[#E30022] hover:underline font-medium flex items-center gap-1">
              Voir tous
              <ChevronRight className="h-4 w-4" />
            </Link>
          </div>

          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 stagger-animation">
            {careerAdvice.map((article) => (
              <Link
                key={article.id}
                to={article.link}
                data-testid={`home-carriere-${article.slug}-link`}
                className="group hover-lift"
              >
                <div className="relative aspect-video rounded-lg overflow-hidden mb-4 img-zoom">
                  <ResponsiveImage sizes="(min-width: 1280px) 282px, (min-width: 1024px) 25vw, (min-width: 640px) 50vw, 100vw"
                    src={article.image}
                    alt={article.title}
                    data-testid={`home-carriere-${article.slug}-image`}
                    className="w-full h-full object-contain"
                    loading="lazy"
                    decoding="async"
                  />
                </div>
                <h4 data-testid={`home-carriere-${article.slug}-title`} className="text-sm font-medium text-gray-800 group-hover:text-[#E30022] transition-colors line-clamp-2">
                  {article.title}
                </h4>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Articles;
